import { Component, Input } from '@angular/core';

export type BadgeIconName =
  | 'heartbeat'
  | 'moon'
  | 'sos'
  | 'pulse'
  | 'sat'
  | 'immo'
  | 'battery'
  | 'battery-low'
  | 'band'
  | 'zone'
  | 'fall';

@Component({
  selector: 'app-badge-icon',
  templateUrl: './badge-icon.component.html',
  styleUrls: ['./badge-icon.component.scss']
})
export class BadgeIconComponent {
  @Input() name: BadgeIconName | string | null = null;
}
